module.exports = __webpack_public_path__ + "static/media/5.574d570c.png";